import { render, staticRenderFns } from "./Large-2.vue?vue&type=template&id=4e0fdb3c"
import script from "./Large-2.vue?vue&type=script&lang=js"
export * from "./Large-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports